/**
 * Client-safe + shared item-request helpers.
 * Do NOT re-export notify / enqueue / process here — those pull Node-only
 * email (nodemailer) and break Client Components via the barrel.
 * Import server owners from their module paths.
 */
export {
  normalizePreferenceAttrs,
  buildPreferenceAttrsFromCapture,
  comparePreferenceAttrs,
  listingAttrsForPreferenceCompare,
  preferenceFitLabel,
  formatPreferenceSummary,
  formatPreferenceSizeLabel,
  preferenceAttrsAreEmpty,
  PREFERENCE_ATTR_SCORE_PER_KEY,
  PREFERENCE_ATTR_SCORE_CAP,
  type PreferenceAttrs,
  type PreferenceFit,
} from "./preferenceAttrs";
export {
  composeItemRequestTitle,
  normalizeItemRequestNotes,
  ITEM_REQUEST_NOTES_MAX_LEN,
} from "./composeRequestTitle";
export { displayItemRequestTitle } from "./displayItemRequestTitle";
export {
  groupRecentRequestsForDemandStrip,
  summarizeCommonPrefs,
  summarizeDemandStripArea,
  areaLabelFromLocation,
  prefsDivergeMaterially,
  pickPrimaryRequest,
  DEMAND_STRIP_GROUP_MIN,
  DEMAND_STRIP_VISIBLE_GROUPS,
  DEMAND_STRIP_VISIBLE_SINGLES,
  DEMAND_STRIP_VISIBLE_ROWS,
  type DemandStripChip,
  type DemandStripGroup,
  type DemandStripEntry,
  type DemandStripArea,
} from "./groupRecentRequestsForDemandStrip";
export { buildSellFromRequestHref } from "./buildSellFromRequestHref";
export {
  parseSellFromRequestSearchParams,
  applySellFromRequestToFormData,
  applySellFromRequestToBulkItem,
  buildSellDescriptionFromRequest,
  SELL_FROM_REQUEST_PARAM,
  type SellFromRequestPrefill,
} from "./sellFromRequestPrefill";
export {
  evaluateBuyerBudgetGuidance,
  BUYER_BUDGET_SOFT_WARN_RATIO,
  BUYER_BUDGET_SOFT_WARN_RATIO_RANGE,
  type BuyerBudgetGuidanceInput,
  type BuyerBudgetGuidanceResult,
} from "./buyerBudgetGuidance";
export {
  MATCH_BAND_LABEL,
  MATCH_BAND_HINT,
  matchBandLabel,
  matchBandHint,
} from "./matchBandCopy";
export { ITEM_REQUEST_CAPTURE_COPY } from "./itemRequestCaptureCopy";
export {
  getItemRequestBuyerStatusPresentation,
  ITEM_REQUEST_BUYER_STATUS_FILTERS,
  type ItemRequestLifecycleStatus,
  type ItemRequestBuyerStatusPresentation,
} from "./itemRequestBuyerStatus";
export {
  validateItemRequestCapture,
  ITEM_REQUEST_MAX_PRICE_MIN,
  ITEM_REQUEST_MAX_PRICE_MAX,
  ITEM_REQUEST_DAILY_CREATE_LIMIT,
  type ItemRequestCaptureInput,
  type ItemRequestCaptureResult,
  type ItemRequestCaptureValid,
} from "./validateItemRequestCapture";
export {
  validateItemRequestEdit,
  type ItemRequestEditInput,
  type ItemRequestEditResult,
  type ItemRequestEditValid,
} from "./validateItemRequestEdit";
export { mapSupabaseItemRequestToItemRequest } from "./mapItemRequest";
export {
  itemRequestApproveFields,
  approveItemRequest,
  setItemRequestReviewStatus,
  type ItemRequestApprovedVia,
} from "./approveItemRequest";
export {
  insertAutoApprovedItemRequest,
  updateOwnerEditableItemRequest,
  updateItemRequestOwnerStatus,
  deleteOwnerItemRequest,
} from "./persistItemRequest";
export { isRequestEligibleForMatch } from "./matchEligibility";
export {
  scoreListingAgainstRequest,
  assignMatchBand,
  resolveMatchGeoTier,
} from "./matchScore";
export { rankScoredMatches } from "./matchRank";
export {
  findMatchesForRequest,
  attachListingThumbnails,
} from "./findMatchesForRequest";
export {
  ITEM_MATCH_LISTING_SELECT,
  itemRowToMatchListing,
  type MatchItemRow,
} from "./matchListingFromItem";
export {
  findMatchingRequestsForListing,
  isNotifyPushBand,
  ITEM_REQUEST_MATCH_NOTIFY_LIMIT,
  type RequestMatchNotifyCandidate,
} from "./findMatchingRequestsForListing";
export {
  buildItemRequestMatchCopy,
  buildItemRequestMatchDedupeKey,
  ITEM_REQUEST_MATCH_EVENT_TYPE,
} from "./itemRequestMatchCopy";
export {
  UNMATCHED_AGING_DAYS,
  agingCutoffIso,
  ageDaysSince,
} from "./unmatchedDemand";
export type {
  MatchBand,
  MatchGeoTier,
  MatchRequestInput,
  MatchListingInput,
  MatchScoreBreakdown,
  ScoredMatch,
  RankedMatches,
} from "./matchTypes";
